export default "__VITE_ASSET__pVYcA0U8__"